import axios from '../axios';

function buildQuery (params) {
  const query = [];
  for (const param in params) {
    const value = params[param];
    if (value !== undefined && value !== null && value !== '') {
      query.push(`${encodeURIComponent(param)}=${encodeURIComponent(value)}`);
    }
  }
  return query.length ? `?${query.join('&')}` : '';
}

export default {
  list ({ limit = 15, read } = {}) {
    const params = { limit };
    if (read !== undefined && read !== null) {
      params['filter[read]'] = read ? 1 : 0;
    }
    return new Promise((resolve, reject) => {
      axios.get(`/lk-notifications${buildQuery(params)}`)
        .then(resolve)
        .catch(reject);
    });
  },

  listAll ({ limit = 100 } = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/lk-notifications/all${buildQuery({ limit })}`)
        .then(resolve)
        .catch(reject);
    });
  },

  create (body) {
    return new Promise((resolve, reject) => {
      axios.post('/lk-notifications', body)
        .then(resolve)
        .catch(reject);
    });
  },

  markRead (id) {
    return new Promise((resolve, reject) => {
      axios.post(`/lk-notifications/${id}/read`)
        .then(resolve)
        .catch(reject);
    });
  },

  markAllRead () {
    return new Promise((resolve, reject) => {
      axios.post('/lk-notifications/read')
        .then(resolve)
        .catch(reject);
    });
  },

  destroy (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/lk-notifications/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },

  destroyRead () {
    return new Promise((resolve, reject) => {
      axios.delete('/lk-notifications/read')
        .then(resolve)
        .catch(reject);
    });
  },
};
